<ng-container *ngIf="filteredOutpatients.length; else noItems">
    <mat-list>
        <div class="list-header" *ngIf="!filterValue">Recent Patients</div>
        <app-patient-list-item *ngFor="let patient of filteredOutpatients | slice:0:shown" [patient]="patient"></app-patient-list-item>
        <div *ngIf="shown < filteredOutpatients.length" (appRenderMore)="shown = shown + renderBatch"></div>
    </mat-list>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noItems>
    <p class="no-records-message">No patients found.</p>
</ng-template>